import { render } from "./UserPage.vue?vue&type=template&id=46b2bc5e&scoped=true&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=46b2bc5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b2bc5e"]])

export default __exports__